import { format, parseISO } from 'date-fns'

import { config } from '../config'
import { paymentMethodMap } from './billingConsts'

function billDownloadCitySegment() {
  return String(config.city ?? '').replace(/\s+/g, '') || 'City'
}

export function buildBillPdfFileName(secondaryId, atDate = new Date()) {
  const cityPart = billDownloadCitySegment()
  const datePart = format(atDate, 'MMddyyyy')
  return `${secondaryId}-${cityPart}-${datePart}.pdf`
}

export function buildBillReceiptPdfFileName(secondaryId, atDate = new Date()) {
  const cityPart = billDownloadCitySegment()
  const datePart = format(atDate, 'MMddyyyy')
  return `${secondaryId}-receipt-${cityPart}-${datePart}.pdf`
}

function formatBillPaymentDetails(bill) {
  if (bill.status === 'WAITING') return

  const details = {}

  if (['PAID', 'REFUNDED'].includes(bill.status)) {
    details['Payment Method'] = paymentMethodMap[bill.paymentMethod]
    details['Payment Date'] = new Date(bill.paymentDate)
    if (bill.paymentNote) {
      details['Note'] = bill.paymentNote
    }
  }

  if (['CANCELLED', 'REJECTED', 'REFUNDED', 'ABANDONED'].includes(bill.status)) {
    let key = 'Cancelled Date'
    if (bill.status === 'REFUNDED') key = 'Refunded Date'
    if (bill.status === 'REJECTED') key = 'Rejected Date'
    if (bill.status === 'ABANDONED') key = 'Abandoned Date'

    details[key] = bill.feeLastModified
  }

  return details
}

function formatPriceStr(amount) {
  return amount < 0 ? `($ ${Math.abs(amount).toFixed(2)})` : `$ ${amount.toFixed(2)}`
}

function getPaidApplicationFeeBills(bills = []) {
  return bills.filter(b => b.type === 'APPLICATION_FEE' && b.status === 'PAID')
}

function formatBillFromServer(bill) {
  const lastModified = bill.feeLastModified || bill.updatedAt

  const sentAt = bill.billState === 'SENT' && bill.type === 'APPLICATION_FEE' && !bill.sentAt ? bill.createdAt : bill.sentAt

  return {
    ...bill,
    sentAt: sentAt ? new Date(sentAt) : undefined,
    paymentDueDate: bill.paymentDueDate ? parseISO(bill.paymentDueDate) : undefined,
    paymentDate: bill.paymentDate ? new Date(bill.paymentDate) : undefined,
    feeLastModified: lastModified ? new Date(lastModified) : undefined,
    paymentNote: bill.paymentNote || undefined,
    total: Number(bill.total),
    amountDue: Number(bill.amountDue),
    percentDue: Number(bill.percentDue)
  }
}

function createBillCommunicationMap(communications) {
  const result = communications.reduce((acc, curr) => {
    if (curr.billId) acc[curr.billId] = curr.id
    return acc
  }, {})

  return result
}

function addCommunicationToBill(bill, billCommunicationMap) {
  return {
    ...bill,
    communicationId: billCommunicationMap[bill.id]
  }
}

function addCommunicationToBills(bills, communications) {
  if (!communications) return bills

  const billCommunicationMap = createBillCommunicationMap(communications)

  return bills.map(b => {
    return addCommunicationToBill(b, billCommunicationMap)
  })
}

export {
  formatBillPaymentDetails,
  formatPriceStr,
  getPaidApplicationFeeBills,
  formatBillFromServer,
  createBillCommunicationMap,
  addCommunicationToBill,
  addCommunicationToBills
}
